import { Component, OnInit, Input, ViewChild, ElementRef, ViewChildren, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: '.app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss']
})
export class TemplateComponent implements OnInit {

  designSelectionSet: any;

  @Input() templateData: any;
  @Input() align: any;
  @Input() parentTag: any;
  @Input() existingElements: any[];
  @Input() parentHeight: any;
  @Input() parentWidth: any;
  @Input()
  set elementDesigns(elementDesigns: any[]) {
    // console.log(storyElementArray);
    this.designSelectionSet = (elementDesigns && (elementDesigns.length > 0)) ? elementDesigns : [];
  }

  // @ViewChild('') : ElementRef;
  @ViewChild('root',{static: false}) rootdiv: ElementRef;
  @ViewChild('zone',{static: false}) zoneRef: ElementRef;
  @ViewChild('child',{static: false}) childRef: ElementRef;
  @Output() updateZoneTemplate = new EventEmitter<any>();

  style = '';

  rootwidth = null;
  rootheight = null;

  selfwidth = null;
  selfheight = null;

  constructor(
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {

    setTimeout(e => {
      if (this.templateData.root) {
        // console.log(this.rootdiv.nativeElement.parentElement.parentElement);
        this.rootheight = this.rootdiv.nativeElement.parentElement.parentElement.scrollHeight;
        this.rootwidth = this.rootdiv.nativeElement.parentElement.parentElement.scrollWidth;
        // console.log(this.rootheight, this.rootwidth);
        this.selfheight = this.templateData.height * this.rootheight / 100;
        this.selfwidth = this.templateData.width * this.rootwidth / 100;

      }
      // console.log(this.parentHeight, this.parentWidth, this.templateData.name);
      if (this.parentHeight && this.parentWidth) {
        this.selfheight = this.templateData.height * this.parentHeight / 100;
        this.selfwidth = this.templateData.width * this.parentWidth / 100;
      }
      // console.log(this.selfheight, this.selfwidth, this.templateData.name);
    }, 1);
  }

  getFromZone(ev) {
    this.updateZoneTemplate.emit(ev);
  }

  getStyle(h, w) {
    if (this.selfheight !== null && this.selfwidth !== null) {
      return this.sanitizer.bypassSecurityTrustStyle(
        'height:' + (h * this.selfheight / 100) + 'px;' + 'width:' + (w * this.selfwidth / 100) + 'px;');
    }
  }

  getRootStyle() {
    // const height = elem.nativeElement.parentElement.scrollHeight;
    // const width = elem.nativeElement.parentElement.scrollWidth;
    return this.sanitizer.bypassSecurityTrustStyle(
      'height:' + (this.selfheight) + 'px;' + 'width:' + (this.selfwidth) + 'px;');

  }

  setStoryHeight() {
    const intViewportHeight = window.innerHeight - 140;
    let styles = {
      'min-height': + intViewportHeight + 'px'
    };
    return styles;
  }
}
